export default "__VITE_ASSET__7a0ab95e__"